import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import Button from 'components/shared/Button'
import Modal from 'components/shared/Modal'
import Link from 'components/shared/Link'
import { closeModalActions } from 'helpers/helpers'
import { useResolutions } from 'store/resolutions'

interface ModalInfoProps {
    children: React.ReactNode
    isOpened: boolean
    buttonLabel: React.ReactNode
    linkLabel?: React.ReactNode
    variant?: 'primary' | 'secondary'
    width?: number
    onButtonClick: () => void
    onLinkClick?: () => void
    isLoading?: boolean
    areButtonsMobileColumn?: boolean
    testIdPrefix?: string
    hasButtonsNoWrap?: boolean
}

const ModalInfo = ({
    children,
    isOpened,
    variant = 'primary',
    buttonLabel,
    linkLabel,
    width = 430,
    onButtonClick,
    onLinkClick,
    isLoading = false,
    areButtonsMobileColumn,
    testIdPrefix,
    hasButtonsNoWrap,
}: ModalInfoProps) => {
    const { isMobile } = useResolutions()

    const handleLinkClick = () => {
        closeModalActions(true)
        onLinkClick && onLinkClick()
    }

    const handleButtonClick = () => {
        closeModalActions(true)
        onButtonClick()
    }

    return (
        <Modal
            isOpened={isOpened}
            isCloseOnOutsideClickEnabled={false}
            hasCloseButton={false}
            maxWidth={width}
        >
            <Box justify="center" pt={[24, 40]} pl={[16, 40]} pr={[16, 40]}>
                {children}
            </Box>
            <Box
                direction={
                    isMobile && areButtonsMobileColumn
                        ? 'column-reverse'
                        : 'row'
                }
                justify="flex-end"
                align="center"
                pt={[24, 24]}
                pb={[24, 40]}
                pl={[16, 40]}
                pr={[16, 40]}
                gap={[10, 24]}
            >
                {!!linkLabel && onLinkClick && (
                    <Link
                        variant="gray"
                        icon={null}
                        onClick={handleLinkClick}
                        isDisabled={isLoading}
                        data-testid={`${
                            testIdPrefix ? testIdPrefix : 'modal-info'
                        }-button-decline`}
                    >
                        <Text
                            variant="body"
                            hasNoWrap={hasButtonsNoWrap}
                            align="right"
                        >
                            {linkLabel}
                        </Text>
                    </Link>
                )}

                <Button
                    onClick={handleButtonClick}
                    variant={variant}
                    hasArrow={false}
                    width={
                        isMobile && areButtonsMobileColumn ? '100%' : 'initial'
                    }
                    isLoading={isLoading}
                    hasNoWrap={hasButtonsNoWrap}
                    testId={`${
                        testIdPrefix ? testIdPrefix : 'modal-info'
                    }-button-confirm`}
                >
                    {buttonLabel}
                </Button>
            </Box>
        </Modal>
    )
}

export default ModalInfo
